import { Injectable, inject } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Observable, forkJoin } from 'rxjs';
import { SearchesState } from './searches.state';
import { Search } from './models/search';
import { GetSavedSearches, GetSearchHistory, PostSearch, DeleteSearch, PostSavedSearchToHistory } from './searches.actions';

@Injectable({
  providedIn: 'root',
})
export class SearchesFacade {
  private readonly store = inject(Store);

  @Select(SearchesState.getSearchHistory) searchHistory$!: Observable<Search[]>;
  @Select(SearchesState.getSavedSearches) savedSearches$!: Observable<Search[]>;
  @Select(SearchesState.getIsLoading) isLoading$!: Observable<boolean>;

  get searchHistory() {
    return this.store.selectSnapshot(SearchesState.getSearchHistory);
  }

  get savedSearches() {
    return this.store.selectSnapshot(SearchesState.getSavedSearches);
  }

  getSearchHistory(): Observable<Search[]> {
    return this.store.dispatch(new GetSearchHistory());
  }

  getSavedSearches(): Observable<Search[]> {
    return this.store.dispatch(new GetSavedSearches());
  }

  postSearch(search: Search): Observable<Search> {
    return this.store.dispatch(new PostSearch(search));
  }

  deleteSearch(savedSearchId: number) {
    return this.store.dispatch(new DeleteSearch(savedSearchId));
  }

  postSavedSearchToHistory(search: Search): Observable<Search> {
    return this.store.dispatch(new PostSavedSearchToHistory(search));
  }

  getHistoryAndSavedSearches() {
    return forkJoin([
      this.store.dispatch(new GetSearchHistory()),
      this.store.dispatch(new GetSavedSearches()),
    ]);
  }

  isSearchSaved(search: Search, history = false) {
    const searches = history ? this.searchHistory : this.savedSearches;
    return searches.some((_search) => _search.query === search.query && _search.facets === search.facets && _search.collectionId === search.collectionId && _search.careerPlanLevelId === search.careerPlanLevelId && _search.challengeId === search.challengeId);
  }
}
